module.exports = __webpack_public_path__ + "static/media/wisepad.ac26ccf9.png";